import React, { useState } from "react";

import OfferList from "./OfferList";
import ListWrapper from "../../../common/management/ListWrapper";
import ListContentWrapper from "../../../common/management/ListContentWrapper";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { genDisplayCount } from "../../../utils/GeneralUtils";
import { useGetOfferAdmin } from "../../../utils/useOffer";

type Props = {
  currentPage: number;
  perView: number;
  isSelect: boolean;
};

const OfferListContainer: React.FC<Props> = ({
  currentPage,
  perView,
  isSelect,
}) => {
  const auth_token = useAppSelector(getAuthToken);

  const {
    items: { total_entries: entries, total_pages: totalPage, offers, meta },
    isLoading,
  } = useGetOfferAdmin({
    auth_token,
    isSelect,
    page: currentPage,
    per: perView,
  });

  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalProps, setModalProps] = useState<string>("");

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const handleModalProps = (value: string) => {
    setModalProps(value);
  };

  return (
    <ListWrapper pageTitle="オファー一覧">
      <ListContentWrapper
        isLoading={isLoading}
        displayCount={genDisplayCount(currentPage, totalPage, perView, entries)}
        totalEntries={entries}
        currentPage={currentPage}
        totalPage={totalPage}
      >
        <OfferList
          offers={offers}
          meta={meta}
          showModal={showModal}
          handleModal={handleModal}
          modalProps={modalProps}
          handleModalProps={handleModalProps}
          isSelect={isSelect}
        />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default OfferListContainer;
